// @ts-check

import React, { useState } from 'react';
import { Mappedin, MapView } from '@mappedin/mappedin-js';

// @ts-ignore
import SearchIcon from '../../../../../infrastructure/assets/svg/search-icon-sm.svg';



/**
 * @typedef {import("../../../types/PL_ReduxTypes").PL_LiveMapPageState} PL_LiveMapPageState
 * 
 * @typedef {import("./../liveMapPageTypes").LiveMapPageActions} LiveMapPageActions
 * 
 * 
 * @typedef {{
 *    mapView:  MapView | undefined, 
 *    sData:    PL_LiveMapPageState, 
 *    actions:  LiveMapPageActions
 * }} MapToolbarOverlayProps

 * 
 */




/**
 * @param {MapToolbarOverlayProps} props
 * 
 */
const MapToolbarOverlay = (props) => {

  // console.log('=========== OVERLAY RENDER ===> ', props);

  let mapView = props.mapView;
  if (!mapView) {
    return null;
  }

  
  
  const [searchValue, setSearchValue] = useState('');
  const handleInputChange = (/** @type {React.ChangeEvent<HTMLInputElement>} */ event) => {
    setSearchValue(event.target.value);
  };

  const handleSearchClick = () => {
    submitSearch(props, searchValue);
  };

  const handleKeyPress = (/** @type {React.KeyboardEvent<HTMLInputElement>} */ event) => {
    if (event.key === 'Enter') {
      submitSearch(props, searchValue);
    }
  };
  
  
  

  return (
    <div className="live-map-overlay-toolbar">


      <div className="live-map-search-controls">
        <div className='livemap-menu-search'>
          <input
            type='text'
            id='txtLivemapsearch'
            placeholder='SEARCH'
            value={searchValue}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
          />

          <SearchIcon />

        </div>
        {/* <button id='btnLivemapsearch'
          // onClick={handleSearchClick}
        >Search</button> */}
      </div>


    </div>
  );

};


export default MapToolbarOverlay;




////////////////////////////////////
// Helper functions
//

/** 
 * @param {MapToolbarOverlayProps} props 
 * @param {string} searchValue 
 */
const submitSearch = (props, searchValue) => {
  console.log('Searching for:', searchValue);

  let sData = props.sData;
  let actions = props.actions;
  console.log('GGGGGGGGGGGGGGGGGGGGG props ===> ', props);
  console.log('GGGGGGGGGGGGGGGGGGGGG sData ===> ', sData);
  console.log('GGGGGGGGGGGGGGGGGGGGG actions ===> ', actions);
  
  actions.searchMap({
    query: searchValue
  });

}
